const {h, render, Component} = require('preact');
const Helper = require('./helper')
const Web2018Helper = require('../../../../helper')

class ExpiryDate extends Component {
  constructor(props) {
    super(props);
    this.getExpiryDate = this.getExpiryDate.bind(this);
  }

  getExpiryDate(claimDetails) {
    if (claimDetails && claimDetails.expiresIn)
      return claimDetails.expiresIn
    return null;
  }

  render() {
    let expiryDate = this.getExpiryDate(this.props.claimDetails);
    let formattedExpiryDate = Helper.getFormattedDateStatus(expiryDate);
    if (expiryDate) {
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.expiry_date")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(formattedExpiryDate.dateStatus)} <span class="claim-days">{formattedExpiryDate.days}</span></td>
        </tr>
      )
    }
    return null;
  }
}

module.exports = ExpiryDate
